import qs from 'query-string';

export const isNavigationDisabled = () => qs.parse(window.location.search).disable_navigation === '1';
